/* eslint-disable no-magic-numbers */
import { TextResources } from '../config/StoreLocatorTextResources';

export class OpeningHoursService {
  /**
   * Propertys
   */
  searchPattern = new RegExp(
    /((([A-Za-z]{2},*)*[A-Za-z]{2}-[A-Za-z]{2})\s+(\d{2}:\d{2}-\d{2}:\d{2}),?(\d{2}:\d{2}-\d{2}:\d{2})?)/,
  ); // Mo,Tu,..,Th-Sa 08:00-20:00
  regexDefault = new RegExp(
    /((([A-Za-z]{2},*)*[A-Za-z]{2}-[A-Za-z]{2}|([A-Za-z]{2},*)*)\s+(\d{2}:\d{2}-\d{2}:\d{2}),?(\d{2}:\d{2}-\d{2}:\d{2})?)/,
  );
  // ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  weekdays = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];
  indexDay = new Date().getDay() - 1;
  // if (indexDay === -1) {
  //   indexDay = 6; // Set to Saturday (last day of the week)
  // }
  opening_hours = [
    { day: 'Mo', status: 'closed', open: '00:00', close: '00:00' },
    { day: 'Tu', status: 'closed', open: '00:00', close: '00:00' },
    { day: 'We', status: 'closed', open: '00:00', close: '00:00' },
    { day: 'Th', status: 'closed', open: '00:00', close: '00:00' },
    { day: 'Fr', status: 'closed', open: '00:00', close: '00:00' },
    { day: 'Sa', status: 'closed', open: '00:00', close: '00:00' },
    { day: 'Su', status: 'closed', open: '00:00', close: '00:00' },
  ];

  getOpeningHours(openingHoursResponse) {
    let splittedResponse = [];
    let openingTime = [];

    /**
     * here the default values are assigned to the opening hours
     */
    const openingHours = JSON.parse(JSON.stringify(this.opening_hours));

    /**
     * checks whether the response consists of several parts
     */
    splittedResponse = openingHoursResponse.split(';');
    for (let i = 0; i < splittedResponse.length; i++) {
      let timeOpen = '';
      let timeClose = '';
      let days = [];

      openingTime = splittedResponse[i].match(this.regexDefault);
      const daysPart = openingTime[2];

      /**
       * the opening and closing times are put together here
       */
      timeOpen = openingTime[5].substr(0, 5);
      // if lunch break is maintained, it will be removed here
      if (openingTime[6] !== undefined) {
        timeClose = openingTime[6].substr(-5, 5);
      } else {
        timeClose = openingTime[5].substr(-5, 5);
      }

      /**
       * the default values are updated with current ones here
       */
      for (let i = 0; i < openingHours.length; i++) {
        if (daysPart.length > 2) {
          days = daysPart.split(/[,]/); // ['Fr', 'Sa'] | ['Mo', 'Tu', 'Th-Sa'] | ['Mo-Sa']
        } else {
          days = [daysPart];
        }

        if (days.length > 1) {
          for (let a = 0; a < days.length; a++) {
            const daysSubPart = days[a];

            if (daysSubPart.length < 1) {
              days = daysSubPart;
            }
          }
        }

        for (let a = 0; a < days.length; a++) {
          const day = days[a];

          if (day.length > 2) {
            const subDays = day.split(/[-]/);
            const startDay = subDays[0];
            const endDay = subDays[1];
            let startIndex = null;
            let endIndex = null;

            this.weekdays.forEach((value, index) => {
              if (value.toUpperCase() === startDay.toUpperCase()) {
                startIndex = index;
              }
              if (value.toUpperCase() === endDay.toUpperCase()) {
                endIndex = index + 1;
              }
            });

            if (startIndex !== null && endIndex !== null) {
              const mergedDays = this.weekdays.slice(startIndex, endIndex);

              if (days.length > 1) {
                days = days.concat(mergedDays);
                for (let b = 0; b < days.length; b++) {
                  if (days[b].length > 2) {
                    days.splice(days.indexOf(days[b]), 1);
                  }
                }
              } else {
                days = mergedDays;
              }
            }
          }
        }
        /**
         * Handle
         */
        days.forEach((value) => {
          if (value.toUpperCase() === openingHours[i]['day'].toUpperCase()) {
            this.updateDayElement(openingHours[i], timeOpen, timeClose);
          }
        });
      }
    }
    return openingHours;
  }

  updateDayElement(element, openTime, closeTime) {
    if (this.isStoreOpen(openTime, closeTime)) {
      element['status'] = 'open';
    }
    element['open'] = openTime;
    element['close'] = closeTime;
  }

  getToday() {
    return this.weekdays[this.indexDay];
  }

  getStoreHours(openingHours) {
    const storeHours = Object.values(openingHours);
    const status = storeHours[this.indexDay]['status'].toUpperCase();

    return this.hourOutput(status, storeHours[this.indexDay]);
  }

  hourOutput(status, storeHour) {
    let hourOutput = '';

    switch (status.toUpperCase()) {
      case 'CLOSED':
        if (this.isStoreOpenSoon(storeHour['open'])) {
          hourOutput +=
            '<span><span id="store-status" style="color:orange">' +
            TextResources.resources['location'].open_soon +
            '</span> - ' +
            TextResources.resources['location'].opens_at +
            ' ' +
            storeHour['open'] +
            '</span></br>';
        } else {
          hourOutput +=
            '<span><span id="store-status" style="color:#c30c15">' +
            TextResources.resources['location'].status_closed +
            '</span></span></br>';
        }
        break;
      case 'OPEN':
        if (this.isStoreCloseSoon(storeHour['close'])) {
          hourOutput +=
            '<span><span id="store-status" style="color:orange">' +
            TextResources.resources['location'].close_soon +
            '</span> - ' +
            TextResources.resources['location'].closes_at +
            ' ' +
            storeHour['close'] +
            '</span></br>';
        } else {
          hourOutput +=
            '<span><span id="store-status" style="color:green">' +
            TextResources.resources['location'].status_open +
            '</span> - ' +
            TextResources.resources['location'].closes_at +
            ' ' +
            storeHour['close'] +
            '</span></br>';
        }
        break;
      default:
        hourOutput += '<span><span id="store-status">' + storeHour['status'] + '</span></span></br>';
        break;
    }
    return hourOutput;
  }

  isStoreOpenSoon(openHour) {
    const today = new Date();
    const now = Date.now();
    const [hours, minutes] = openHour.split(':');
    const openStoreHour = today.setHours(hours, minutes);
    const diffMinutes = (now - openStoreHour) / 60000;

    if (diffMinutes <= -1 && diffMinutes >= -60) {
      return true;
    } else {
      return false;
    }
  }

  isStoreCloseSoon(closeHour) {
    const today = new Date();
    const now = Date.now();
    const [hours, minutes] = closeHour.split(':');
    const closeStoreHour = today.setHours(hours, minutes);
    const diffMinutes = (now - closeStoreHour) / 60000;

    if (diffMinutes <= -1 && diffMinutes >= -30) {
      return true;
    } else {
      return false;
    }
  }

  isStoreOpen(openHour, closeHour) {
    const today = new Date();
    const now = Date.now();
    const [hoursOpen, minutesOpen] = openHour.split(':');
    const [hoursClose, minutesClose] = closeHour.split(':');
    const openStoreHour = today.setHours(hoursOpen, minutesOpen);
    const closeStoreHour = today.setHours(hoursClose, minutesClose);

    if (now <= closeStoreHour && now >= openStoreHour) {
      return true;
    } else {
      return false;
    }
  }
}

export const HOURS = new OpeningHoursService();
